// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] + "." + {"126":"2177fbcb","285":"ff358edb","631":"a2964583"}[chunkId] + ".chunk.css";
};